export default "__VITE_PUBLIC_ASSET__e36f17db__"